export default $axios => ({
    getSeoArticle(slug) {
        return $axios({
            method: 'GET',
            url: `/general/seo/article?article_slug=${slug}`
        });
    },
    getArticle(slug) {
        return $axios({
            method: 'GET',
            url: `/base/articles/${slug}`,
            redirectOnError: true
        });
    },
    getRecommendedArticles(slug) {
        return $axios({
            method: 'GET',
            url: `/base/articles/recommended/${slug}`
        });
    }
});
